import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const liveTranslateFn = (data) => apiClient.post(`${APP_API_URL}translations/live-translate`, data);

export const useLiveTranslateMutation = () => {
  return useMutation({
    mutationFn: liveTranslateFn,
  });
};
